import { render, staticRenderFns } from "./mTab.vue?vue&type=template&id=b90bc3f2&"
import script from "./mTab.vue?vue&type=script&lang=js&"
export * from "./mTab.vue?vue&type=script&lang=js&"
import style0 from "./mTab.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports